import React from "react";

import {
    Typography,
    Grid,
    List,
    ListItem,
    TablePagination,
    IconButton,
    Tooltip,
    TableSortLabel,
} from "@material-ui/core";
import "../style.css";
import { Edit as EditIcon, RemoveRedEye as ViewIcon } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
import styled from "styled-components";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import {
    selectRowCount,
    selectPageIndex,
    selectSortTableType,
    getRequesting,
    selectSortTableKey,
} from "./selectors";

import {
    setRowCount,
    setPageIndex,
    setSortTableType,
    setSortTableKey,
    setSortTableAs,
} from "./actions";
const noImg = require("./imgProfile.png");
const StyledListItem = styled(ListItem)`
    background: white;
    border: 1px solid #ddd;
    border-radius: 0px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-top: 24px;
    border-left: 4px solid ${(props) => props.borderColor};
    :first & {
        margin-top: 0px;
    }
`;
class TableList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rowsPerPage: 50,
            page: 0,
        };
    }
    GridHeadCell = (label, key, width, sortable, sortAs) => {
        return (
            <Grid item sm={12} md={12} lg={width} xl={width}>
                {(sortable && (
                    <Tooltip
                        title="Sort"
                        placement={"bottom-start"}
                        enterDelay={300}
                    >
                        <TableSortLabel
                            active={this.props.sortTableKey === key}
                            direction={this.props.sortTableType || "asc"}
                            onClick={() => {
                                this.props.setSortTableKey(key);
                                this.props.setSortTableAs(sortAs);
                                switch (this.props.sortTableType) {
                                    case "asc": {
                                        this.props.setSortTableType("desc");
                                        break;
                                    }
                                    case "desc": {
                                        this.props.setSortTableType("asc");
                                        break;
                                    }
                                    default: {
                                        return;
                                    }
                                }
                            }}
                        >
                            <Typography
                                variant="body2"
                                style={{ paddingLeft: 24 }}
                            >
                                <b>{label}</b>
                            </Typography>
                        </TableSortLabel>
                    </Tooltip>
                )) || (
                    <Typography variant="body2" style={{ paddingLeft: 24 }}>
                        <b>{label}</b>
                    </Typography>
                )}
            </Grid>
        );
    };

    render() {
        const {
            toolboxes,

            width,
        } = this.props;
        const { page, rowsPerPage } = this.state;
        return (
            <div style={{ width: "100%", overflow: "scrollX" }}>
                <List style={{ background: "#eee", marginTop: 24 }}>
                    <ListItem
                        style={{
                            width: "100%",
                            background: "white",

                            boxShadow:
                                "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                        }}
                    >
                        <div style={{ float: "right" }}>
                            {" "}
                            <TablePagination
                                colSpan={6}
                                ActionsComponent={TablePaginationHelper}
                                count={toolboxes.length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                onChangePage={(event, page) =>
                                    this.setState({ page })
                                }
                                onChangeRowsPerPage={(event) => {
                                    this.setState({
                                        rowsPerPage: event.target.value,
                                    });
                                }}
                                rowsPerPageOptions={[50, 180]}
                            />
                        </div>
                    </ListItem>
                    <ListItem
                        style={{
                            background: "white",
                            boxShadow:
                                "0 6px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                        }}
                    >
                        <Grid container spacing={4}>
                            {!["xl", "lg"].includes(width) &&
                                this.GridHeadCell(
                                    "Toolbox Details",
                                    "icon_url",
                                    12,
                                    false,
                                    "string"
                                )}
                            {["xl", "lg"].includes(width) &&
                                this.GridHeadCell(
                                    "Topic",
                                    "toolbox_topic",
                                    2,
                                    true,
                                    "string"
                                )}

                            {["xl", "lg"].includes(width) &&
                                this.GridHeadCell(
                                    "Category",
                                    "category",
                                    2,
                                    true,
                                    "string"
                                )}

                            {["xl", "lg"].includes(width) &&
                                this.GridHeadCell(
                                    "Completed Talks",
                                    "completed_talks",
                                    2,
                                    true,
                                    "talks_completed"
                                )}
                            {["xl", "lg"].includes(width) &&
                                this.GridHeadCell(
                                    "Created On",
                                    "created_timestamp",
                                    2,
                                    true,
                                    "date"
                                )}
                            {["xl", "lg"].includes(width) &&
                                this.GridHeadCell(
                                    "Created By",
                                    "created_by",
                                    2,
                                    true,
                                    "created"
                                )}
                            {["xl", "lg"].includes(width) && (
                                <Grid item sm={0} md={0} lg={0} xl={0}>
                                    <Typography variant="body2">
                                        <b>Actions</b>
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </ListItem>
                    {toolboxes &&
                        toolboxes
                            .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                            )
                            .map((toolbox, index) => {
                                let toolboxProfile = toolbox.profile;

                                let toolboxReports = toolbox.reports
                                    ? Object.keys(toolbox.reports).length
                                    : 0;

                                let imgErr = false;
                                return (
                                    <StyledListItem
                                        borderColor={"#0188CC"}
                                        style={{
                                            root: {
                                                borderLeft: "#0188CC",
                                            },
                                        }}
                                    >
                                        <Grid container spacing={4}>
                                            <Grid
                                                item
                                                sm={12}
                                                md={12}
                                                lg={2}
                                                xl={2}
                                                style={{ paddingLeft: 24 }}
                                            >
                                                <img
                                                    style={{
                                                        width: "50%",
                                                        height: "auto",
                                                    }}
                                                    onError={() => {
                                                        imgErr = true;
                                                    }}
                                                    src={
                                                        toolboxProfile.icon_url !==
                                                            "" &&
                                                        toolboxProfile.icon_url &&
                                                        !imgErr
                                                            ? toolboxProfile.icon_url
                                                            : noImg
                                                    }
                                                    alt={
                                                        toolboxProfile.icon_url !==
                                                            "" &&
                                                        toolboxProfile.icon_url &&
                                                        !imgErr
                                                            ? toolboxProfile.icon_url
                                                            : noImg
                                                    }
                                                />
                                                <Typography
                                                    variant="body2"
                                                    style={{}}
                                                >
                                                    {
                                                        toolboxProfile.toolbox_topic
                                                    }
                                                </Typography>
                                            </Grid>

                                            <Grid
                                                item
                                                sm={12}
                                                md={12}
                                                lg={2}
                                                xl={2}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    style={{
                                                        padding: [
                                                            "xl",
                                                            "lg",
                                                        ].includes(width)
                                                            ? "50px 0"
                                                            : "0",
                                                        paddingLeft: 24,
                                                    }}
                                                >
                                                    {toolboxProfile.category}
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                item
                                                sm={12}
                                                md={12}
                                                lg={2}
                                                xl={2}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    style={{
                                                        padding: [
                                                            "xl",
                                                            "lg",
                                                        ].includes(width)
                                                            ? "50px 0"
                                                            : "0",
                                                        paddingLeft: 24,
                                                    }}
                                                >
                                                    {toolboxReports}
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                item
                                                sm={12}
                                                md={12}
                                                lg={2}
                                                xl={2}
                                            >
                                                <Typography
                                                    style={{
                                                        padding: [
                                                            "xl",
                                                            "lg",
                                                        ].includes(width)
                                                            ? "50px 0"
                                                            : "0",
                                                        paddingLeft: 24,
                                                    }}
                                                >
                                                    {
                                                        toolboxProfile.created_timestamp
                                                    }
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                item
                                                sm={12}
                                                md={12}
                                                lg={2}
                                                xl={2}
                                            >
                                                <Typography
                                                    style={{
                                                        padding: [
                                                            "xl",
                                                            "lg",
                                                        ].includes(width)
                                                            ? "50px 0"
                                                            : "0",
                                                        paddingLeft: 24,
                                                    }}
                                                >
                                                    {
                                                        toolboxProfile
                                                            .created_by
                                                            .user_name
                                                    }
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                item
                                                sm={12}
                                                md={12}
                                                lg={1}
                                                xl={1}
                                            >
                                                <div
                                                    style={{
                                                        padding: [
                                                            "xl",
                                                            "lg",
                                                        ].includes(width)
                                                            ? "50px 0"
                                                            : "0",
                                                        paddingLeft: 24,
                                                        minWidth: 100,
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                    }}
                                                >
                                                    <Link
                                                        to={`/toolbox-view/${toolboxProfile.toolbox_id}/`}
                                                    >
                                                        <IconButton
                                                            style={{
                                                                color: "indigo",
                                                                border:
                                                                    "1px solid indigo",
                                                            }}
                                                        >
                                                            <ViewIcon />
                                                        </IconButton>
                                                    </Link>
                                                    <Link
                                                        to={`/toolbox-edit/${toolboxProfile.toolbox_id}/`}
                                                    >
                                                        <IconButton
                                                            style={{
                                                                color: "red",
                                                                border:
                                                                    "1px solid red",
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Link>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </StyledListItem>
                                );
                            })}
                </List>
            </div>
        );
    }
}

export default hot(module)(
    connect(
        (store) => {
            return {
                requesting: getRequesting(store),
                rowCount: selectRowCount(store),
                pageIndex: selectPageIndex(store),
                sortTableType: selectSortTableType(store),
                sortTableKey: selectSortTableKey(store),
            };
        },
        {
            setRowCount,
            setPageIndex,
            setSortTableType,
            setSortTableKey,
            setSortTableAs,
        }
    )(TableList)
);
